<div class="trinka_cloud_wrap">
    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>Plagiarism Checker</h1>
                            <h2>Detect Similarity Against World's Largest Paid and Open Access Database</h2>
                            <p>Trusted by leading universities and publishers, it goes beyond just webpages to check your content for plagiarism against 190 million+ paywalled articles.</p>
                            <div class="btn-group">
                                <a href="https://cloud.trinka.ai/signup?_rg=GB" class="filled-btn" target="_blank" rel="noopener noreferrer">Check Your File Now</a>
                            </div>
                        </div>
                        <div class="top-banner-right">
                            <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="../../../../../assets/images/plagiarism-check/plagiarism-check.jpg">
                                <source src="../../../../../assets/images/plagiarism-check/plagiarism-check.mp4#t=0.1" type="video/mp4">
                                Your browser does not support the video element. Kindly update it to latest version.
                            </video>
                            <button class="icon-pause button-play" (click)="playPause()" [ngClass]="video_pause ? 'icon-play' : 'icon-pause'" [attr.aria-label]="video_pause ? 'Play video' : 'Pause video'"> </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<section class="trinka-banner section-pd stats-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards line-r">
                    <div class="media">
                        <div class="media-left">
                            <h2>Top Feature</h2>
                            <h3>190<span>Million+</span></h3>
                        </div>
                        <div class="media-body">
                            <p>Paid Scholarly Articles & Papers</p>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="col-lg-3 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards line-r">
                    <div class="media">
                        <div class="media-left">
                            <h3>99<span>Billion+</span></h3>
                        </div>
                        <div class="media-body">
                            <p>Current & Archived Webpages</p>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="col-lg-3 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards line-r">
                    <div class="media">
                        <div class="media-left">
                            <h3>200<span>Million+</span></h3>
                        </div>
                        <div class="media-body">
                            <p>Open Access <br/>Articles</p>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="col-lg-3 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <div class="media">
                        <div class="media-left">
                            <h3>102<span>Million+</span></h3>
                        </div>
                        <div class="media-body">
                            <p>Pages Crawled and Updated Daily</p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</section>


<section class="section-pd bg-light">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka’s Plans Include Plagiarism Checks</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">Run Plagiarism and AI Content Checks on all your work without worrying about limits,<br class="d-lg-block d-none"/> with built-in checks included in our plans.</p>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-sm-6 dflex">
                <div class="c-card trinkaPlans">
                    <span class="shape">
                        <svg width="295" height="357" viewBox="0 0 295 357" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.6" filter="url(#filter0_f_1688_1351)">
                            <rect x="144" y="-33.8896" width="140.829" height="358.851" transform="rotate(-27.0801 144 -33.8896)" fill="url(#paint0_linear_1688_1351)" fill-opacity="0.5"/>
                            </g>
                            <defs>
                            <filter id="filter0_f_1688_1351" x="0" y="-242" width="576.752" height="671.621" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                            <feGaussianBlur stdDeviation="72" result="effect1_foregroundBlur_1688_1351"/>
                            </filter>
                            <linearGradient id="paint0_linear_1688_1351" x1="214.414" y1="-33.8896" x2="218.245" y2="347.003" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#7B2FBE"/>
                            <stop offset="1" stop-color="#6E6EFF"/>
                            </linearGradient>
                            </defs>
                        </svg>
                    </span>
                    <h3>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M28.2364 13.3904L24.5662 7.94641C24.4202 7.7307 24.1737 7.60059 23.9099 7.60059H11.1244C10.8605 7.60059 10.6141 7.7307 10.4682 7.94641L6.79788 13.3904C6.60204 13.6797 6.62818 14.0614 6.86147 14.3217L16.925 25.6103C17.0737 25.778 17.2894 25.8739 17.5167 25.8739C17.7439 25.8739 17.9597 25.778 18.1091 25.6095L28.1726 14.3209C28.4051 14.0614 28.4313 13.6797 28.2364 13.3904ZM13.0719 14.5861L15.511 21.6828L9.18411 14.5861H13.0719ZM19.3314 9.14209L20.3861 13.0454H14.6454L15.7001 9.14209H19.3314ZM20.3004 14.5861L17.5163 22.689L14.7322 14.5861H20.3004ZM21.9608 14.5861H25.8488L19.5219 21.6828L21.9608 14.5861ZM26.118 13.0445H22.0142L20.9595 9.14126H23.4867L26.118 13.0445ZM11.5467 9.14204H14.0739L13.0192 13.0453H8.91451L11.5467 9.14204Z" fill="#763393"/>
                            <path d="M6.9116 1.80859L7.837 4.30945L10.3379 5.23484L7.837 6.16024L6.9116 8.66109L5.9862 6.16024L3.48535 5.23484L5.9862 4.30945L6.9116 1.80859Z" fill="#763393"/>
                            <path d="M3.4868 7.51892L4.10374 9.18616L5.77097 9.80309L4.10374 10.42L3.4868 12.0873L2.86987 10.42L1.20264 9.80309L2.86987 9.18616L3.4868 7.51892Z" fill="#763393"/>
                        </svg>
                        Premium Plus   
                    </h3>
                    <h6>240 pages/year</h6>
                    <p>Enough to check <b>~20 full documents</b> per year.</p>
                    <span class="sm-title">Use it for:</span>
                    <ul class="bt-list">
                        <li>
                            <b class="d-block">Standard Plagiarism Check</b>
                            <small>Check against 99 Billion+ Internet sources and 200 Million+ open access papers.</small>
                        </li>
                        <li>
                            <b class="d-block">AI Content Detection Report</b>
                        </li>
                    </ul>
                    <div class="btn-group mt-3">
                        <a
                            [href]="buildPlanCheckoutUrl('premium plus', {
                                utm_source: 'website',
                                utm_medium: 'get_now',
                                utm_campaign: 'plagiarism_check_premium_plus',
                                utm_id: 'premium_plus_plagiarism_check'
                            })"
                            class="filled-btn"
                            target="_blank"
                        >
                            Get Now
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="c-card trinkaPlans cdpPlan">
                    <span class="shape">
                        <svg width="306" height="357" viewBox="0 0 306 357" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.6" filter="url(#filter0_f_1688_1397)">
                            <rect x="144" y="-59.9896" width="140.829" height="358.851" transform="rotate(-27.0801 144 -59.9896)" fill="url(#paint0_linear_1688_1397)" fill-opacity="0.5"/>
                            </g>
                            <defs>
                            <filter id="filter0_f_1688_1397" x="0" y="-268.1" width="576.752" height="671.621" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                            <feGaussianBlur stdDeviation="72" result="effect1_foregroundBlur_1688_1397"/>
                            </filter>
                            <linearGradient id="paint0_linear_1688_1397" x1="214.414" y1="-59.9896" x2="218.245" y2="320.903" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#7B2FBE"/>
                            <stop offset="0.346154" stop-color="#10B981"/>
                            </linearGradient>
                            </defs>
                        </svg>
                    </span>
                    <h3>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1688_1355)">
                            <path d="M29.9295 8.4355C29.9295 7.80958 29.4219 7.30243 28.796 7.30243C28.5852 7.30243 28.4031 7.30243 28.3134 7.30243C24.2929 7.30243 20.7427 5.87514 17.8371 3.25902C17.3637 2.83281 16.6353 2.83281 16.1619 3.25903C13.2565 5.87506 9.70657 7.30243 5.6862 7.30243C5.59656 7.30243 5.41436 7.30243 5.20347 7.30243C4.57757 7.30243 4.06995 7.80955 4.06992 8.43545C4.06988 9.54832 4.06982 11.2455 4.06982 12.4196C4.06982 21.6216 9.56404 29.3536 16.9997 31.5459C24.4353 29.3536 29.9295 21.6216 29.9295 12.4196C29.9295 11.2455 29.9295 9.54837 29.9295 8.4355Z" fill="#16A34A"/>
                            <g clip-path="url(#clip1_1688_1355)">
                            <path d="M12.4921 24.4375H21.5072C21.8806 24.4375 22.1833 24.1348 22.1833 23.7614V16.0985C22.1833 15.7251 21.8806 15.4223 21.5072 15.4223H20.8311V13.3939C20.8311 11.2813 19.1123 9.5625 16.9996 9.5625C14.887 9.5625 13.1682 11.2813 13.1682 13.3939V15.4223H12.4921C12.1186 15.4223 11.8159 15.7251 11.8159 16.0985V23.7614C11.8159 24.1348 12.1186 24.4375 12.4921 24.4375ZM17.6758 20.1547V21.0568C17.6758 21.4302 17.373 21.733 16.9996 21.733C16.6262 21.733 16.3235 21.4302 16.3235 21.0568V20.1547C16.05 19.9489 15.8727 19.6217 15.8727 19.2538C15.8727 18.6324 16.3783 18.1269 16.9996 18.1269C17.621 18.1269 18.1265 18.6324 18.1265 19.2538C18.1265 19.6217 17.9493 19.9489 17.6758 20.1547ZM14.5205 13.3939C14.5205 12.0269 15.6326 10.9148 16.9996 10.9148C18.3666 10.9148 19.4788 12.0269 19.4788 13.3939V15.4223H14.5205V13.3939Z" fill="white"/>
                            </g>
                            </g>
                            <defs>
                            <clipPath id="clip0_1688_1355">
                            <rect width="34" height="34" rx="17" fill="white"/>
                            </clipPath>
                            <clipPath id="clip1_1688_1355">
                            <rect width="14.875" height="14.875" fill="white" transform="translate(9.5625 9.5625)"/>
                            </clipPath>
                            </defs>
                        </svg>
                        Confidential Data
                    </h3>
                    <h6>1,000 pages/year</h6>
                    <p>Enough to check <b>~80 full documents</b> per year.</p>
                    <span class="sm-title">Use it for:</span>
                    <ul class="bt-list">
                        <li>
                            <b class="d-block">Standard Plagiarism Check</b>
                        </li>
                        <li>
                            <b class="d-block">AI Content Detection Report</b>
                        </li>
                    </ul>
                    <small class="plus">+</small>
                    <ul class="bt-list">
                        <li>
                            <b>12 Advanced Checks</b> (one/month) that compare against world’s largest database of <b>190 Million+ paid publications</b>.
                        </li>
                    </ul>
                    <div class="btn-group mt-3">
                        <a
                            [href]="buildPlanCheckoutUrl('confidential data', {
                                coupon: 'BTS40',
                                utm_source: 'website',
                                utm_medium: 'get_now',
                                utm_campaign: 'plagiarism_check_cdp',
                                utm_id: 'cdp_plagiarism_check'
                            })"
                            class="filled-btn"
                            target="_blank"
                        >
                            Get Now
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row justify-content-center">
            <div class="col-12">
                <div class="btn-group justify-content-center mt-40">
                    <a href="https://cloud.trinka.ai/signup?_rg=GB" class="filled-btn" target="_blank">Get Started</a>
                    <a [routerLink]="['/pricing']" class="outline-btn">
                        Explore Pricing Plans 
                    </a>
                </div>
            </div>
        </div> -->
    </div>
</section>

<section class="plagCheckKeyFeatures section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Key Features</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="tabs-wrap">
                    <ul class="nav nav-pills" role="tablist" aria-label="Key features">
                        <li class="nav-item">
                            <a
                                id="freeScore-tab"
                                class="nav-link active"
                                data-toggle="pill"
                                href="#freeScore"
                                role="tab"
                                aria-controls="freeScore"
                                aria-selected="true"
                                (click)="activateTab('freeScore')">
                                <span>Plagiarism Score</span>
                            </a>
                        </li>
                
                        <li class="nav-item">
                            <a
                                id="standardPlagiarism-tab"
                                class="nav-link"
                                data-toggle="pill"
                                href="#standardPlagiarism"
                                role="tab"
                                aria-controls="standardPlagiarism"
                                aria-selected="false"
                                (click)="activateTab('standardPlagiarism')">
                                <span>
                                    Standard Plagiarism
                                    <br class="d-lg-block d-none" />
                                    Check
                                </span>
                            </a>
                        </li>
                
                        <li class="nav-item">
                            <a
                                id="advancedPlagiarism-tab"
                                class="nav-link"
                                data-toggle="pill"
                                href="#advancedPlagiarism"
                                role="tab"
                                aria-controls="advancedPlagiarism"
                                aria-selected="false"
                                (click)="activateTab('advancedPlagiarism')">
                                <span>
                                    Advanced Plagiarism
                                    <br class="d-lg-block d-none" />
                                    Check
                                </span>
                            </a>
                        </li>
                
                    </ul>
                </div>
                <div class="tab-content">
                    <div id="freeScore" class="tab-pane active" role="tabpanel" tabindex="-1" aria-labelledby="freeScore-tab">
                        <div class="pc-para">
                            <!-- <span>Checks Against Internet Sources & Detects AI-generated Content</span> -->
                            <span>Check Against Content From Internet Sources</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-left">
                                    <div id="accordion_free" class="accordion">
                                        <div class="card" [ngClass]="freeshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="freeScore(1)" data-toggle="collapse" href="#freecollapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="" aria-hidden="true" /></span>
                                                    Top 3 Matching Sources
                                                </a>
                                            </div>
                                            <div id="freecollapseOne" class="collapse show" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>Top matching sources along with the match percentage are listed down.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(2)" data-toggle="collapse" href="#freecollapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="" aria-hidden="true" /></span>
                                                    Shows Overall Similarity Score
                                                </a>
                                            </div>
                                            <div id="freecollapseTwo" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>The document will be graded with the content similarity score based on the Plagiarism issues detected.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(3)" data-toggle="collapse" href="#freecollapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/global.svg" alt="" aria-hidden="true" /></span>
                                                    Score for Internet Match
                                                </a>
                                            </div>
                                            <div id="freecollapseThree" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>The document shows individual scores for Internet sources.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="freeshowTab == 1 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/matching-scroe.svg" alt="matching-score" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/overall-score.svg" alt="overall-score" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 3 ? 'show' : ''">
                                        <div class="text-center">

                                            <img
                                                src="../../../../assets/images/plagiarism-check/overall-paid.svg"
                                                alt="Plagiarism match result indicator"
                                                aria-describedby="match-description"
                                                class="flags"
                                            >
                                        
                                            <div id="match-description" class="sr-only">
                                                <p>
                                                    The result shows greater than 90% internet match and greater than 2% paid publication match.
                                                </p>
                                            </div>
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="standardPlagiarism" class="tab-pane" role="tabpanel" tabindex="-1" aria-labelledby="standardPlagiarism-tab">
                        <div class="pc-para">
                            <!-- <span>Checks Against Internet Sources & Detects AI-generated Content</span> -->
                            <span>Check Against Content From Internet Sources</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion_standard" class="accordion">
                                        <!-- <div class="card" [ngClass]="standardshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(1)" data-toggle="collapse" href="#standardcollapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/cpu-charge.svg" alt="icon" /></span>
                                                    AI-generated Content Detector
                                                </a>
                                            </div>
                                            <div id="standardcollapseOne" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>Detects content generated by Large Language Models such as ChatGPT.</p>
                                                </div>
                                            </div>
                                        </div> -->
                                      
                                        <div class="card" [ngClass]="standardshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(2)" data-toggle="collapse" href="#standardcollapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    Identifies Top Matching Sources
                                                </a>
                                            </div>
                                            <div id="standardcollapseTwo" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>Lists down the top matching sources along with the match percentage.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="standardshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(3)" data-toggle="collapse" href="#standardcollapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="text icon" /></span>
                                                    Highlights Matched Text
                                                </a>
                                            </div>
                                            <div id="standardcollapseThree" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>For a matched source, the Report highlights the exact matched text.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(4)" data-toggle="collapse" href="#standardcollapseFour">
                                                    <span><img src="../../../../assets/images/plagiarism-check/flag-2.svg" alt="flag icon" /></span>
                                                    Flags Hidden Content
                                                </a>
                                            </div>
                                            <div id="standardcollapseFour" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>Detects and flags hidden text and suspicious characters in a document.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(5)" data-toggle="collapse" href="#standardcollapseFive">
                                                    <span><img src="../../../../assets/images/plagiarism-check/share_1.svg" alt="icon" /></span>
                                                    Excludes Chosen Sections
                                                </a>
                                            </div>
                                            <div id="standardcollapseFive" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>Provides flexibility to exclude chosen sections in a document from the scope of check.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="c-card key-features-right">
                                    <!-- <div class="image video-feature" [ngClass]="standardshowTab == 1 ? 'show' : ''">
                                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="../../../assets/images/videos/posters/plagiarism-check.jpg">
                                            <source src="../../../../assets/images/plagiarism-check/AI-Content-Detector.mp4#t=0.1" type="video/mp4">
                                            Your browser does not support the video element. Kindly update it to latest version.
                                        </video>
                                    </div> -->
                                    <div class="image" [ngClass]="standardshowTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/features/plagiarism-check/sources.webp" alt="paid publications" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/features/plagiarism-check/highlight.webp" alt="paid publications" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 4 ? 'show' : ''">
                                        <img src="../../../../assets/images/features/plagiarism-check/flags-hidden.webp" alt="paid publications" class="flags" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 5 ? 'show' : ''">
                                        <img src="../../../../assets/images/features/plagiarism-check/eclude-choosen.webp" alt="paid publications" class="exclude choosen" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="advancedPlagiarism" class="tab-pane" role="tabpanel" tabindex="-1" aria-labelledby="advancedPlagiarism-tab">
                        <div class="pc-para">
                            <span>Checks Against Paid Publications & Internet Sources. <br/>
                                Recommended plagiarism checker for academic papers.</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion" class="accordion">
                                        <div class="card" [ngClass]="showTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="advancePlagiarism(1)" data-toggle="collapse" href="#collapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    Identifies Top Matching Sources
                                                </a>
                                            </div>
                                            <div id="collapseOne" class="collapse show" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>Lists down the top matching sources along with the match percentage.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(2)" data-toggle="collapse" href="#collapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="text icon" /></span>
                                                    Highlights Matched Text
                                                </a>
                                            </div>
                                            <div id="collapseTwo" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>For a matched source, the Report highlights the exact matched text.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(3)" data-toggle="collapse" href="#collapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/flag-2.svg" alt="flags icon" /></span>
                                                    Flags Hidden Content
                                                </a>
                                            </div>
                                            <div id="collapseThree" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>Detects and flags hidden text and suspicious characters in a document.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(4)" data-toggle="collapse" href="#collapseFour">
                                                    <span><img src="../../../../assets/images/plagiarism-check/export.svg" alt="exclude icon" /></span>
                                                    Exclude Chosen Sections
                                                </a>
                                            </div>
                                            <div id="collapseFour" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>Provides flexibility to exclude chosen sections in a document from the scope of check.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(5)" data-toggle="collapse" href="#collapseFive">
                                                    <span><img src="../../../../assets/images/plagiarism-check/share_1.svg" alt="share icon" /></span>
                                                    Provides Sharing Options
                                                </a>
                                            </div>
                                            <div id="collapseFive" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>Gives multiple options to seamlessly share your Report.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="showTab == 1 ? 'show' : ''">
                                        <img src="../../../../assets/images/features/plagiarism-check/sources.webp" alt="sources" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/features/plagiarism-check/highlight.webp" alt="highlight" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/features/plagiarism-check/flags-hidden.webp" alt="flags" class="flags" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 4 ? 'show' : ''">
                                        <img src="../../../../assets/images/features/plagiarism-check/eclude-choosen.webp" alt="exclude" class="exclude choosen" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 5 ? 'show' : ''">
                                        <img src="../../../../assets/images/features/plagiarism-check/share.webp" alt="exclude sections" class="share" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="writing_need_sections section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Find the Plagiarism Check That Suits you Best</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Sources/Features</th>
                                    <th>
                                        Plagiarism Score
                                    </th>
                                    <th>Standard Plagiarism Check </th>
                                    <th>Advanced Plagiarism Check</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr>
                                    <td>AI-generated Content Detector <span class="newbadge">New</span></td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                </tr> -->
                                <tr>
                                    <td>190 Million+ Paid Scholarly Articles</td>
                                    <td>
                                        -
                                    </td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>99 Billion+ Current & Archived Web Pages</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>200 Million+ Open Access Articles</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>102 Million Pages Crawled & Updated Daily</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Interactive Reports with Downloadable PDF</td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" role="img">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Trinka Premium Plus and Confidential Data Plan Offers Unlimited Access to Standard Plagiarism Reports</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="/pricing"
                    routerLinkActive="active"
                    class="white-btn"
                    aria-label="Know More - Pricing Plans">

                        <span>Know More</span>

                        <svg xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="20"
                            viewBox="0 0 21 20"
                            fill="none"
                            aria-hidden="true"
                            focusable="false">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="#000"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="#000"/>
                        </svg>

                    </a>
                </div>
            </div>
        </div>  
    </div>
</div>

<section class="section-pd">
    <app-credits-info
        [title]="'Plagiarism Check Uses Credits'"
        [description]="'Standard Plagiarism Check uses 24 credits, and Advanced Plagiarism Check uses 36 credits. Use your free monthly credits and buy more only when you need.'"
        [subText]="'Credits are like tokens that let you use several Trinka features as needed.<br/> Users get free credits every month based on the subscription plan. To know more, <a href=&quot;/features/credits&quot; class=&quot;text-link&quot;>click here</a>.<br/>Trinka\'s paid subscribers get up to 64% discount on credit pack purchases.'"
    ></app-credits-info>
</section>

<section class="section-pd section-grey">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2>How to Get Started</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <div class="allPlans-wrapper">
                        <div class="plan-content plan-simple">
                            <div class="plan-header"></div>
                            <ul>
                                <li>Standard Report/Score</li>
                                <li>Advanced Report/Score</li>
                                <li>New Balance Credits Every Month </li>
                                <!-- <li>Additional Credit Discounting / Purchase</li> -->
                                <li>Cost for Bulk Purchase of Credits</li>
                            </ul>
                        </div>
                        <div class="plan-content plan-basic">
                            <div class="plan-header">
                                Basic
                            </div>
                            <ul>
                                <li><span>Available for <b>24 Credits </b></span></li>
                                <li><span>Available for <b>36 Credits</b></span></li>
                                <li><span><b>4 Credits </b> Each Month</span></li>
                                <!-- <li><span><b>6 USD </b> per Extra Credit Purchase</span></li> -->
                                <li><span>Only <b class="d-inline"> 1.50 USD</b> per credit<br/> ( Pack of 80 )</span></li>
                            </ul>
                        </div>
                        <div class="plan-content plan-premium">
                            <div class="plan-header">
                                Premium
                            </div>
                            <ul>
                                <li><span>Available for <b>24 Credits </b></span></li>
                                <li><span>Available for <b>36 Credits</b></span></li>
                                <li><span><b>10 Credits</b> Each Month</span></li>
                                <!-- <li><span><b>3.6 USD</b> per Extra Credit Purchase</span></li> -->
                                <li><span>Only <b class="d-inline">0.9 USD</b> per credit<br/> ( Pack of 80 )</span></li>
                            </ul>
                        </div>
                        <div class="plan-content plan-premium">
                            <div class="plan-header">
                                Premium Plus
                            </div>
                            <ul>
                                <li><span><b>Up to 240 pages</b>(1 page = 250 words)</span></li>
                                <li><span>Available for <b>36 Credits</b></span></li>
                                <li><span><b>20 Credits </b> Each Month</span></li>
                                <!-- <li><span><b>3.6 USD </b> per Extra Credit Purchase</span></li> -->
                                <li><span>Only <b class="d-inline"> 0.9 USD</b> per credit<br/> ( Pack of 80 )</span></li>
                            </ul>
                        </div>
                        <div class="plan-content plan-recommended">
                            <div class="plan-header">
                            Confidential Plan
                                <span>Recommended</span>
                            </div>
                            <ul>
                                <li><span><b>Up to 1,000 pages</b>(1 page = 250 words)</span></li>
                                <li><span>Available for <b>36 Credits</b></span></li>
                                <li><span><b>50 Credits </b> Each Month</span></li>
                                <!-- <li><span><b>3.6 USD </b> per Extra Credit Purchase</span></li> -->
                                <li><span>Only <b class="d-inline"> 0.9 USD</b> per credit<br/> ( Pack of 80 )</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd standOut">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>What Makes Trinka Plagiarism Checker Stand Out? </h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        <span class="sr-only">Features</span>
                                    </th>
                                    <th scope="col">Trinka & <br/> Enago Reports</th>
                                    <th scope="col" class="grammarly">Grammarly</th>
                                    <th scope="col" class="quillbot">Quillbot</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <p>
                                            Advanced Plagiarism Check
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>
                                            Standard Plagiarism Reports
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>Unlimited Access to Similarity Report
                                        <span class="custom-tooltip">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M10 1.04164C14.9417 1.04165 18.9584 5.05831 18.9584 9.99998C18.9584 14.9416 14.9417 18.9583 10 18.9583C5.05837 18.9583 1.04171 14.9416 1.04171 9.99998C1.04171 5.05831 5.05838 1.04164 10 1.04164ZM10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 9.99998C17.7084 5.74998 14.25 2.29165 10 2.29164C5.75004 2.29164 2.29171 5.74998 2.29171 9.99998C2.29171 14.25 5.75004 17.7083 10 17.7083Z" fill="#414E62"/>
                                                <path d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665L10.625 13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333L9.375 9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z" fill="#414E62"/>
                                                <path d="M10 5.83335C10.1084 5.83335 10.2167 5.85835 10.3167 5.90002C10.4167 5.94168 10.5084 6.00002 10.5917 6.07502C10.6667 6.15835 10.725 6.24168 10.7667 6.35002C10.8084 6.45002 10.8334 6.55835 10.8334 6.66668C10.8334 6.77502 10.8084 6.88335 10.7667 6.98335C10.725 7.08335 10.6667 7.17502 10.5917 7.25835C10.5084 7.33335 10.4167 7.39168 10.3167 7.43335C10.1167 7.51668 9.88337 7.51668 9.68337 7.43335C9.58337 7.39168 9.49171 7.33335 9.40837 7.25835C9.33337 7.17502 9.27504 7.08335 9.23337 6.98335C9.19171 6.88335 9.16671 6.77502 9.16671 6.66668C9.16671 6.55835 9.19171 6.45002 9.23337 6.35002C9.27504 6.24168 9.33337 6.15835 9.40837 6.07502C9.49171 6.00002 9.58337 5.94168 9.68337 5.90002C9.78337 5.85835 9.89171 5.83335 10 5.83335Z" fill="#414E62"/>
                                            </svg>
                                            <div class="custom-tooltip-content custom-tooltip-transform">
                                                Available with Premium Plus Plan
                                            </div>
                                        </span></p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>20 pages/mo</td>
                                </tr>
                                <tr>
                                    <td>Downloadable PDF Report</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <title>Checked</title>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Avail Unlimited Access to Standard Plagiarism Reports</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a [routerLink]="['/pricing']" class="white-btn">
                        <span>View Plan</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="#000"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="#000"/>
                          </svg>
                    </a>
                </div>
                <small class="text-white d-block text-center mt-1">* Available for Premium Plus and Confidential Data Plan</small>
            </div>
        </div>  
    </div>
</div>

<section class="suitableForSection section-pd">
    <div class="trinka_container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>Who can Benefit from Trinka’s Plagiarism Checker  
                    </h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M36.1056 8.34517L20.4134 3.06772C20.145 2.97743 19.8547 2.97743 19.5863 3.06772L3.89413 8.34517C3.63374 8.43275 3.40727 8.60077 3.2468 8.82542C3.08632 9.05008 2.99998 9.31999 3 9.59692V22.7906C3 23.1405 3.13777 23.4761 3.38301 23.7235C3.62825 23.9709 3.96086 24.1099 4.30768 24.1099C4.6545 24.1099 4.98711 23.9709 5.23235 23.7235C5.47759 23.4761 5.61536 23.1405 5.61536 22.7906V11.4275L11.106 13.273C9.6472 15.6508 9.18331 18.5156 9.81618 21.2382C10.4491 23.9608 12.1269 26.3187 14.4814 27.7942C11.5392 28.9586 8.99572 31.0646 7.13554 33.9441C7.0388 34.0892 6.9716 34.2522 6.93785 34.4237C6.90411 34.5952 6.90449 34.7718 6.93897 34.9431C6.97345 35.1145 7.04134 35.2772 7.1387 35.4219C7.23607 35.5665 7.36095 35.6902 7.50611 35.7857C7.65126 35.8812 7.81379 35.9467 7.98424 35.9783C8.15469 36.0099 8.32966 36.007 8.49899 35.9697C8.66831 35.9325 8.82862 35.8617 8.97057 35.7614C9.11253 35.6611 9.23332 35.5333 9.32591 35.3855C11.7893 31.5726 15.6796 29.3874 19.9999 29.3874C24.3201 29.3874 28.2105 31.5726 30.6738 35.3855C30.8656 35.6731 31.1619 35.873 31.4986 35.942C31.8353 36.011 32.1854 35.9435 32.4732 35.7541C32.7609 35.5647 32.9633 35.2687 33.0364 34.93C33.1096 34.5913 33.0477 34.2372 32.8642 33.9441C31.004 31.0646 28.4507 28.9586 25.5183 27.7942C27.8705 26.3188 29.5468 23.9624 30.1796 21.2418C30.8123 18.5211 30.3499 15.6584 28.8937 13.2812L36.1056 10.8569C36.366 10.7694 36.5926 10.6014 36.7531 10.3767C36.9136 10.1521 37 9.88212 37 9.60516C37 9.3282 36.9136 9.05827 36.7531 8.8336C36.5926 8.60894 36.366 8.44094 36.1056 8.35342V8.34517ZM27.8459 18.8325C27.8463 20.084 27.5525 21.3177 26.9888 22.4325C26.425 23.5473 25.6073 24.5113 24.6028 25.2455C23.5982 25.9797 22.4355 26.4632 21.2099 26.6562C19.9843 26.8492 18.7308 26.7463 17.5523 26.3559C16.3738 25.9655 15.3038 25.2987 14.4301 24.4103C13.5564 23.5219 12.904 22.4371 12.5263 21.245C12.1486 20.0529 12.0565 18.7875 12.2574 17.5525C12.4583 16.3175 12.9466 15.1482 13.6821 14.1405L19.5863 16.1195C19.8547 16.2098 20.145 16.2098 20.4134 16.1195L26.3176 14.1405C27.3111 15.4994 27.8467 17.1438 27.8459 18.8325Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h3>Students</h3>
                        <p>Trinka's plagiarism checker helps students ensure their work is original and properly cited, 
                            significantly reducing the risk of unintentional plagiarism. It also aids in learning proper citation 
                            practices for upholding the academic writing standards. 
                            </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                            <path d="M27.4833 3.33331H13.5167C7.45001 3.33331 3.83334 6.94998 3.83334 13.0166V26.9833C3.83334 31.6666 5.98334 34.8833 9.76668 36.1C10.8667 36.4833 12.1333 36.6666 13.5167 36.6666H27.4833C28.8667 36.6666 30.1333 36.4833 31.2333 36.1C35.0167 34.8833 37.1667 31.6666 37.1667 26.9833V13.0166C37.1667 6.94998 33.55 3.33331 27.4833 3.33331ZM34.6667 26.9833C34.6667 30.55 33.2667 32.8 30.45 33.7333C28.8333 30.55 25 28.2833 20.5 28.2833C16 28.2833 12.1833 30.5333 10.55 33.7333H10.5333C7.75001 32.8333 6.33334 30.5666 6.33334 27V13.0166C6.33334 8.31665 8.81668 5.83331 13.5167 5.83331H27.4833C32.1833 5.83331 34.6667 8.31665 34.6667 13.0166V26.9833Z" fill="#763393"/>
                            <path d="M20.5 13.3333C17.2 13.3333 14.5334 16 14.5334 19.3C14.5334 22.6 17.2 25.2833 20.5 25.2833C23.8 25.2833 26.4667 22.6 26.4667 19.3C26.4667 16 23.8 13.3333 20.5 13.3333Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h3>Authors and Researchers</h3>
                        <p>Authors & researchers can use Trinka to scan their manuscripts for potential plagiarism, ensuring their work remains unique, safeguarding their reputation for originality - an essential step in maintaining the integrity of their documents.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path d="M28.05 26.0667C29.1667 25.3333 30.6333 26.1333 30.6333 27.4667V29.6167C30.6333 31.7333 28.9833 34 27 34.6667L21.6833 36.4333C20.75 36.75 19.2333 36.75 18.3167 36.4333L13 34.6667C11 34 9.36667 31.7333 9.36667 29.6167V27.45C9.36667 26.1333 10.8333 25.3333 11.9333 26.05L15.3667 28.2833C16.6833 29.1667 18.35 29.6 20.0167 29.6C21.6833 29.6 23.35 29.1667 24.6667 28.2833L28.05 26.0667Z" fill="#763393"/>
                            <path d="M33.3 10.7667L23.3167 4.21672C21.5167 3.03339 18.55 3.03339 16.75 4.21672L6.71667 10.7667C3.5 12.8501 3.5 17.5667 6.71667 19.6667L9.38334 21.4001L16.75 26.2001C18.55 27.3834 21.5167 27.3834 23.3167 26.2001L30.6333 21.4001L32.9167 19.9001V25.0001C32.9167 25.6834 33.4833 26.2501 34.1667 26.2501C34.85 26.2501 35.4167 25.6834 35.4167 25.0001V16.8001C36.0833 14.6501 35.4 12.1501 33.3 10.7667Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h3>Educators</h3>
                        <p>Educators can leverage Trinka to check students' submissions for plagiarism, promoting a culture of 
                            academic honesty. It also serves as a teaching tool to educate students about the importance of 
                            originality in their work. 
                            </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                            <path d="M35.5 36.6666H5.5C4.81667 36.6666 4.25 36.1 4.25 35.4166C4.25 34.7333 4.81667 34.1666 5.5 34.1666H35.5C36.1833 34.1666 36.75 34.7333 36.75 35.4166C36.75 36.1 36.1833 36.6666 35.5 36.6666Z" fill="#763393"/>
                            <path d="M32.2 5.79998C28.9667 2.56664 25.8 2.48331 22.4833 5.79998L20.4667 7.81664C20.3 7.98331 20.2333 8.24998 20.3 8.48331C21.5667 12.9 25.1 16.4333 29.5167 17.7C29.5833 17.7166 29.65 17.7333 29.7167 17.7333C29.9 17.7333 30.0667 17.6666 30.2 17.5333L32.2 15.5166C33.85 13.8833 34.65 12.3 34.65 10.7C34.6667 9.04998 33.8667 7.44998 32.2 5.79998Z" fill="#763393"/>
                            <path d="M26.5167 19.2167C26.0333 18.9834 25.5667 18.75 25.1167 18.4834C24.75 18.2667 24.4 18.0334 24.05 17.7834C23.7667 17.6 23.4333 17.3334 23.1167 17.0667C23.0833 17.05 22.9667 16.95 22.8333 16.8167C22.2833 16.35 21.6667 15.75 21.1167 15.0834C21.0667 15.05 20.9833 14.9334 20.8667 14.7834C20.7 14.5834 20.4167 14.25 20.1667 13.8667C19.9667 13.6167 19.7333 13.25 19.5167 12.8834C19.25 12.4334 19.0167 11.9834 18.7833 11.5167C18.6716 11.2773 18.5713 11.0417 18.4789 10.8117C18.3429 10.4735 17.9062 10.3771 17.6485 10.6349L7.73333 20.55C7.51666 20.7667 7.31666 21.1834 7.26666 21.4667L6.36666 27.85C6.19999 28.9834 6.51666 30.05 7.21666 30.7667C7.81666 31.35 8.64999 31.6667 9.54999 31.6667C9.74999 31.6667 9.94999 31.65 10.15 31.6167L16.55 30.7167C16.85 30.6667 17.2667 30.4667 17.4667 30.25L27.3746 20.3421C27.6342 20.0825 27.5355 19.6393 27.1952 19.5017C26.9754 19.4129 26.7516 19.3185 26.5167 19.2167Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h3>Editors</h3>
                        <p>Editors can rely on Trinka to verify the originality of submitted articles, ensuring the content they 
                            publish is free of plagiarism. This helps maintain the publication's credibility and trustworthiness. 
                            </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">      
                        <svg fill="#763393" width="40px" height="40px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"></path></g></svg>
                    </div>
                    <div class="media-body">
                        <h3>Institution</h3>
                        <p>Institutes can benefit from Trinka's plagiarism checker by ensuring the originality of publications by students and faculty. It helps maintain academic integrity, prevents unintentional plagiarism, and supports quality research output, strengthening the institution's reputation.
                            </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">                   
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M34.1667 16.9833H29.35C25.4 16.9833 22.1834 13.7666 22.1834 9.81659V4.99992C22.1834 4.08325 21.4334 3.33325 20.5167 3.33325H13.45C8.31669 3.33325 4.16669 6.66659 4.16669 12.6166V27.3833C4.16669 33.3333 8.31669 36.6666 13.45 36.6666H26.55C31.6834 36.6666 35.8334 33.3333 35.8334 27.3833V18.6499C35.8334 17.7333 35.0834 16.9833 34.1667 16.9833ZM19.2167 22.5499C18.9667 22.7999 18.65 22.9166 18.3334 22.9166C18.0167 22.9166 17.7 22.7999 17.45 22.5499L16.25 21.3499V28.3333C16.25 29.0166 15.6834 29.5833 15 29.5833C14.3167 29.5833 13.75 29.0166 13.75 28.3333V21.3499L12.55 22.5499C12.0667 23.0333 11.2667 23.0333 10.7834 22.5499C10.3 22.0666 10.3 21.2666 10.7834 20.7833L14.1167 17.4499C14.2334 17.3499 14.35 17.2666 14.4834 17.1999C14.5167 17.1833 14.5667 17.1666 14.6 17.1499C14.7 17.1166 14.8 17.0999 14.9167 17.0833C14.9667 17.0833 15 17.0833 15.05 17.0833C15.1834 17.0833 15.3167 17.1166 15.45 17.1666C15.4667 17.1666 15.4667 17.1666 15.4834 17.1666C15.6167 17.2166 15.75 17.3166 15.85 17.4166C15.8667 17.4333 15.8834 17.4333 15.8834 17.4499L19.2167 20.7833C19.7 21.2666 19.7 22.0666 19.2167 22.5499Z" fill="#763393"/>
                            <path d="M29.05 14.6834C30.6333 14.7001 32.8333 14.7001 34.7167 14.7001C35.6667 14.7001 36.1667 13.5834 35.5 12.9167C33.1 10.5001 28.8 6.15007 26.3333 3.6834C25.65 3.00007 24.4667 3.46674 24.4667 4.41674V10.2334C24.4667 12.6667 26.5333 14.6834 29.05 14.6834Z" fill="#763393"/>
                        </svg>    
                    </div>
                    <div class="media-body">
                        <h3>Publishers</h3>
                        <p>Publishers can use Trinka to screen texts before publication, ensuring that all material is original and 
                            adheres to copyright laws, thereby protecting the publisher from legal issues and preserving the 
                            author's credibility. 
                             </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h2 class="h2-title">Covers 1700+ Paid Scientific Journals</h2>
                    <p>
                        Utilize the most accurate text similarity detection algorithms to verify plagiarism in your content and preserve its integrity and credibility. Compare your work against articles published by Wiley, Springer Nature, Taylor & Francis, Sage, and many more prestigious publishers.
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../../assets/images/features/plagiarism-check/plagiarism-check-map.webp" loading="lazy" decoding="async" alt="global publications" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h2 class="h2-title">Get Top-Quality Assessment with Trinka's Plagiarism Check</h2>
                    <p>Due to the many plagiarism detectors, choosing one can be difficult. To simplify this process, we analyzed several popular plagiarism checkers and found Trinka to be the most accurate and dependable. </p>
                    <p>Trinka's Plagiarism Checker surpassed most tools on a substantially plagiarized thesis. We examined 3 leading tools on accuracy, database size, accessibility, ease of use, cost, and security using 6 metrics. Trinka offers top-notch assessment and expertise while protecting your data.</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../../assets/images/features/plagiarism-check/plagiarism-check-graph.webp" loading="lazy" decoding="async" alt="trinka plagiarism check against competitors" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="section-lg">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-xl-6 col-md-12">
                <div class="section-tl">
                    <h2>Covers 1700+ Paid Scientific Journals</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Utilize the most accurate text similarity detection algorithms to verify plagiarism in your content and preserve its integrity and credibility. Compare your work against articles published by Elsevier, Wiley, Springer Nature, Taylor & Francis, Sage, and many more prestigious publishers.</p>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 offset-xl-1  col-md-12">
                <div class="no-image">
                    <img src="../../../../assets/images/plagiarism-check/plagiarism-check-map.png" alt="plag check map" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg pt-0">
    <div class="trinka_container">
        <div class="row">
            <div class="col-md-8">
                <div class="section-tl">
                    <h2>Get Top-Quality Assessment with Trinka's Plagiarism Check</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-xl-6 col-md-12">
                <div class="section-tl">
                    <p>Selecting the right tool can be challenging due to the availability of several plagiarism checkers. In order to make this process easier for you, we compared a number of widely used plagiarism checkers, and Trinka provides the most reliable and accurate results.</p>
                    <p>When tested on a highly plagiarized sample thesis document, Trinka Plagiarism Checker outperformed most other tools.</p>
                    <p>Based on 6 parameters, we compared 3 leading tools on accuracy, database size, accessibility, ease of use, cost, and security. Trinka provides top-of-the-line assessment and expertise, all while keeping your data secure.
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 offset-xl-1  col-md-12">
                <div class="no-image">
                    <img src="../../../../assets/images/plagiarism-check/plagiarism-check-graph.jpg" alt="plag check graph" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section> -->

<div class="cloud_key_features section-pd list-wrapper-style-2" style="background-color: #F5F7F8;">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Why Choose Trinka Plagiarism Checker?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <div class="list-wrapper-content-2 list-style-cards bt-none">
                            <img src="../../../assets/images/languageScore_icon.svg" width="40" height="40" alt="free plagiarism check"/>
                            <h3>Plagiarism check/score available every month</h3>
                            <p>Check for plagiarism in your content, before generating a report. Your document is checked for plagiarism across the Internet, Open Access, and Paid publications.</p>
                        </div>
                    </div>
                    <!-- <div class="col-lg-6 col-md-6">
                        <div class="list-wrapper-content-2 list-style-cards">
                            <img src="../../../assets/images/plagiarism-check/ai-content-detector.svg" width="40" height="40" alt="ppc"/>
                            <h3>AI-generated content detection</h3>
                            <p>Safeguard content integrity by detecting AI-generated text while checking for plagiarism from any LLMs like ChatGPT, GPT-4, Bard, Bing Chat instantly.</p>
                        </div>
                    </div> -->
                    <div class="col-lg-6 col-md-6">
                        <div class="list-wrapper-content-2 list-style-cards">
                            <img src="../../../assets/images/plagiarism-check/standard-check.svg" width="40" height="40" alt="standard plagiarism check"/>
                            <h3>Unlimited standard plagiarism check</h3>
                            <p>Get unlimited access to standard plagiarism check, which checks your content against Internet sources and Open Access publications.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="list-wrapper-content-2 list-style-cards bt-1">
                            <img src="../../../assets/images/plagiarism-check/detection-technology.svg" width="40" height="40" alt="superior detection technology"/>
                            <h3>Superior detection technology</h3>
                            <p>View a detailed table of revisions by language category for a quick understanding of the type of edits made.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="list-wrapper-content-2 list-style-cards bt-1">
                            <img src="../../../assets/images/TypeOrImportFile_icon.png" width="32" height="40" style="min-width: 32px;max-width: 32px;" alt="upload files"/>
                            <h3>Upload MS Word or<br class="d-lg-block d-none"/> PDF files</h3>
                            <p>Trinka's Plagiarism Checks work on both MS Word files (.doc/.docx) and PDF files.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-security-section></app-security-section>

<div class="testimonial-section text-center section-pd">
    <app-testimonial></app-testimonial>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Avoid Plagiarism & Submit Your Work Confidently</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup" class="white-btn" target="_blank" rel="noopener noreferrer">Get Started</a>
                </div>
            </div>
        </div>  
    </div>
</div>


<div class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Frequently Asked Questions</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        How does Trinka's Plagiarism Check work?</a>
                                </div>
    
                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <h4>That’s easy!</h4>
                                        <ol>
                                            <li>Go to your Trinka Cloud Account (haven’t signed up for free account yet? <a href="https://cloud.trinka.ai/signup" class="text-link" target="_blank" rel="noopener noreferrer">Sign up now!</a> )</li>
                                            <li>Navigate to the <strong>Plagiarism Check page by clicking on it from the right panel.</strong></li>
                                            <li>Upload a document and select the check that works for you. You can choose a file you have already uploaded on Trinka drive, too.</li>
                                            <li>Get the detailed report in minutes!</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        How is Trinka’s Plagiarism Check different from others? </a>
                                </div>
    
                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Unlike other tools, Trinka lets you choose a plagiarism check that meets your needs – Internet content or Internet + paid publications.
                                            Our technology offers superior detection technology that is trusted by large academic publishers worldwide.</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Can the Plagiarism Check report be downloaded?
                                    </a>
                                </div>
    
                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes! The reports are in PDF and can be downloaded any time after you generate them.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        Is my content saved by Trinka?
                                    </a>
                                </div>
    
                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka does not store your document and hence, it is not added to any databases. Once the report is generated, the report is shared directly on your dashboard and not stored anywhere else.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            
    
                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        What is an online plagiarism tool?
                                    </a>
                                </div>
    
                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>An online plagiarism tool is a web-based application designed to help users find out plagiarism in their written content. By using advanced algorithms, it scans plagiarism online to detect any instances of copied or duplicated text.</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        How can I find out plagiarism using an online tool?
                                    </a>
                                </div>
    
                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>To find out plagiarism, simply use an online plagiarism tool like Trinka. Paste your text or upload your document into the platform, and it will scan plagiarism online by comparing your content to a vast database of existing content across the internet and paid publications. It will then provide a detailed report highlighting any similarities or matches with other sources.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                        aria-controls="QuestionEightContent">
                                        What file types can I upload in Trinka to check plagiarsm?
                                    </a>
                                </div>
    
                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka AI can check for plagiarism on your MS Word files (.doc / .docx) as well as PDF files.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/Mc_EZXIzvFU"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>